import React, { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import axios from 'axios';
import qs from 'qs';

import { DownCarotIcon, DownloadButton } from '../../components/icons';
import StatusLabel from '../../components/StatusLabel';
import { Order, Search, Document, Property } from '../types';
import { downloadSearchDocuments } from '../../components/utilities/fileUtilities';
import {
  OuterCard,
  ClosedCard,
  ExpandSection,
  DetailTitle,
  Details,
  SearchCardStyles,
  SearchDetailTitle,
  SearchHeaders,
  DetailSection,
  SearchInfo,
  SearchCardInBetween,
  DetailSectionDesktop,
  PropertyInfo,
  SearchCardDesktop,
  DropdownOuter,
} from './styles';
import Button from '../../components/Button';
import SearchActionsDropdown from './SearchActionsDropdown';
import Iframe from '../../components/utilities/Iframe';
import UploadSdaModal from './UploadSdaModal';
import { useUserContext } from '../../context/UserContext';
import { Checkbox } from 'semantic-ui-react';
import { Modal } from 'semantic-ui-react';
import SearchCard from './SearchCard';

interface Props {
  addresses: string;
  addressLine2: string;
  section: string;
  county: string;
  municipalityType: string;
  subMunicipalityType: string;
  municipality: string;
  subMunicipality: string;
  block: string;
  lot: string;
  searches: Search[];
  number: number;
  swisCode: string;
  defaultOpen: boolean;
  order: Order;
  uploadStatus?: boolean;
  onDownload: () => void;
  otherSdaProperties: Property[];
  propertyId: number;
  getOrderDetails: () => void;
  searchesToDownload: number[];
  setSearchesToDownload: React.Dispatch<React.SetStateAction<any[]>>;
}
function GetDateInCurrentTimeZone(date: any) {
  const browserTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const utcDate = moment.tz(date, 'Universal');
  return moment(utcDate).tz(browserTZ);
}

const download = (props: PropTypes) => {
  downloadSearchDocuments(props.order.titleNumber, true, props.searchType, props.searchId);
};

const PropertyCard = (props: Props) => {
  const [uploadSdaOpen, setUploadSdaOpen] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [searchIdsOpen, setSearchIdsOpen] = useState([]);
  const { user } = useUserContext();
  const closeDropdownForSearch = (searchId: number) => {
    const searchesOpen = [...searchIdsOpen].filter(s => {
      return s !== searchId;
    });
    setSearchIdsOpen(searchesOpen);
  };
  const openDropdownForSearch = (searchId: number) => {
    const searchesOpen = [...searchIdsOpen];
    searchesOpen.push(searchId);
    setSearchIdsOpen(searchesOpen);
  };
  const closeAllSearches = () => {
    setSearchIdsOpen([]);
  };
  const updateSearch = async (searchType: any, note: string) => {
    const objToPost = {
      searchTypes: [searchType],
      propertyIds: [props.propertyId],
      properties: [
        {
          propertyId: props.propertyId,
          propertyAddress: props.addresses,
          sbl: `${props.section ? `${props.section}-` : ''}${props.block}-${props.lot}`,
        },
      ],
      note,
      clientName: user.clientName,
      orderId: props.order.id,
      userId: user.id,
      titleNumber: props.order.titleNumber,
      userName: `${user.firstName || ''} ${user.lastName || ''}`,
      isContin: true
    };
    await axios.post(`/api/clientSearch/AddSearchesToOrder`, objToPost);
    props.getOrderDetails();
  };
  const handleSearchCheckChange =
    (searchId: number) =>
    (e: any, { checked }) => {
      const completedSearchesIds = props.searches.filter(s => {
        return s.searchStatusType === 'Completed' && s.propertyId === props.propertyId;
      }).map(s => s.id);

      const newSearchesToDownload = checked
        ? props.searchesToDownload.concat([searchId])
        : props.searchesToDownload.filter(s => s !== searchId);
      props.setSearchesToDownload(newSearchesToDownload);
      setSelectAll(completedSearchesIds.length === newSearchesToDownload.filter(s => completedSearchesIds.includes(s)).length);
    };


  const handleSelectAllChange = (e, { checked }) => {
    const searchesForProperty = props.searches.filter((s => s.searchStatusType === 'Completed' && s.propertyId === props.propertyId)).map(s => s.id)
    
    props.setSearchesToDownload(
      checked ? props.searchesToDownload.concat(searchesForProperty.filter(s => !props.searchesToDownload.includes(s))) : props.searchesToDownload.filter((s) => !searchesForProperty.includes(s))
    );
    setSelectAll(checked);
  };
  const completedStatus =
    props.searches.filter(s => {
      return s.searchStatusType === 'Completed';
    }).length > 0;
  return (
    <>
      <OuterCard>
        <ClosedCard>
          <PropertyInfo>
            <div style={{ marginRight: 8 }}>
              {props.addresses} {props.addressLine2 && props.addressLine2}
            </div>
            {props.uploadStatus && (
              <Button
                onClick={(e: MouseEvent) => {
                  e.stopPropagation();
                  setUploadSdaOpen(!uploadSdaOpen);
                }}
                buttonType="ButtonSecondarySmall"
                buttonText="Upload SDA"
              />
            )}
          </PropertyInfo>
          <DetailSectionDesktop>
            {props.municipalityType && (
              <Details>
                <DetailTitle>{props.municipalityType}:</DetailTitle>
                <div>{props.municipality}</div>
              </Details>
            )}
            {props.subMunicipalityType && (
              <Details>
                <DetailTitle>{props.subMunicipalityType}:</DetailTitle>
                <div>{props.subMunicipality}</div>
              </Details>
            )}
            {props.county && (
              <Details>
                <DetailTitle>County:</DetailTitle>
                <div>{props.county}</div>
              </Details>
            )}

            {/* {props.swisCode && (
                <Details>
                  <DetailTitle>SWIS:</DetailTitle>
                  <div>{props.swisCode}</div>
                </Details>
              )} */}
            {props.municipalityType !== 'Borough' && props.section && (
              <Details>
                <DetailTitle>Section:</DetailTitle>
                <div>{props.section}</div>
              </Details>
            )}
            {props.block && (
              <Details>
                <DetailTitle>Block:</DetailTitle>
                <div>{props.block}</div>
              </Details>
            )}
            {props.lot && (
              <Details>
                <DetailTitle>Lot:</DetailTitle>
                <div>{props.lot}</div>
              </Details>
            )}
          </DetailSectionDesktop>
          <SearchCardDesktop>
            <SearchHeaders>
              <div style={{ position: 'absolute', top: 16 }}>
                {completedStatus && (
                  <Checkbox
                    disabled={props.searches.filter(s => s.searchStatusType === 'Completed').length === 0}
                    checked={selectAll}
                    onChange={handleSelectAllChange}
                  />
                )}
              </div>
              <div style={{ marginLeft: 24 }}>Search</div>
              <div>Date Ordered</div>
              <div>Current Status</div>
              <div>Town Fee</div>
              <div></div>
            </SearchHeaders>
            {props.searches.map(s => {
              return (
                <SearchCard
                  searchId={s.id}
                  searchType={s.searchTypeTruncated}
                  status={s.searchStatusType}
                  dateOrdered={GetDateInCurrentTimeZone(s.dateAdded).format('MM/DD/YYYY')}
                  order={props.order}
                  documentsSearches={s.documentsSearches}
                  fee={s.townFee + s.countyFee}
                  sdaOpen={() => setUploadSdaOpen(true)}
                  updateSearch={updateSearch}
                  searchesToDownload={props.searchesToDownload}
                  handleSearchCheckChange={handleSearchCheckChange}
                  completedStatus={completedStatus}
                  closeDropdownForSearch={closeDropdownForSearch}
                  openDropdownForSearch={openDropdownForSearch}
                  closeAllSearches={closeAllSearches}
                  searchIdsOpen={searchIdsOpen}
                  searchTypeId={s.searchTypeId}
                  downloadSda={props.onDownload}
                  download={download}
                />
              );
            })}
          </SearchCardDesktop>
        </ClosedCard>

        <ExpandSection>
          <DetailSection>
            {props.county && (
              <Details>
                <DetailTitle>County:</DetailTitle>
                <div>{props.county}</div>
              </Details>
            )}
            {props.municipalityType && (
              <Details>
                <DetailTitle>{props.municipalityType}</DetailTitle>
                <div>{props.municipality}</div>
              </Details>
            )}
            {props.subMunicipalityType && (
              <Details>
                <DetailTitle>{props.subMunicipalityType}</DetailTitle>
                <div>{props.subMunicipality}</div>
              </Details>
            )}
            {props.swisCode && (
              <Details>
                <DetailTitle>SWIS:</DetailTitle>
                <div>{props.swisCode}</div>
              </Details>
            )}
            {props.section && (
              <Details>
                <DetailTitle>Section:</DetailTitle>
                <div>{props.section}</div>
              </Details>
            )}
            {props.block && (
              <Details>
                <DetailTitle>Block:</DetailTitle>
                <div>{props.block}</div>
              </Details>
            )}
            {props.lot && (
              <Details>
                <DetailTitle>Lot:</DetailTitle>
                <div>{props.lot}</div>
              </Details>
            )}
          </DetailSection>
          {props.searches.map(s => {
            return (
              <SearchCardMobile
                searchId={s.id}
                searchType={s.searchTypeTruncated}
                status={s.searchStatusType}
                dateOrdered={GetDateInCurrentTimeZone(s.dateAdded).format('MM/DD/YYYY')}
                order={props.order}
                documentsSearches={s.documentsSearches}
                fee={s.townFee + s.countyFee}
                sdaOpen={() => setUploadSdaOpen(true)}
                updateSearch={updateSearch}
                searchesToDownload={props.searchesToDownload}
                handleSearchCheckChange={handleSearchCheckChange}
                completedStatus={completedStatus}
                closeDropdownForSearch={closeDropdownForSearch}
                openDropdownForSearch={openDropdownForSearch}
                closeAllSearches={closeAllSearches}
                searchIdsOpen={searchIdsOpen}
                downloadSda={props.onDownload}
              />
            );
          })}
          <SearchCardInBetween>
            {props.searches.map(s => {
              return (
                <SearchCard
                  searchId={s.id}
                  searchType={s.searchTypeTruncated}
                  status={s.searchStatusType}
                  dateOrdered={GetDateInCurrentTimeZone(s.dateAdded).format('MM/DD/YYYY')}
                  order={props.order}
                  documentsSearches={s.documentsSearches}
                  fee={s.townFee + s.countyFee}
                  sdaOpen={() => setUploadSdaOpen(true)}
                  updateSearch={updateSearch}
                  searchesToDownload={props.searchesToDownload}
                  handleSearchCheckChange={handleSearchCheckChange}
                  completedStatus={completedStatus}
                  closeDropdownForSearch={closeDropdownForSearch}
                  openDropdownForSearch={openDropdownForSearch}
                  closeAllSearches={closeAllSearches}
                  searchIdsOpen={searchIdsOpen}
                  downloadSda={props.onDownload}
                  download={download}
                  searchTypeId={s.searchTypeId}
                />
              );
            })}
          </SearchCardInBetween>
        </ExpandSection>
        {uploadSdaOpen && (
          <UploadSdaModal
            open={uploadSdaOpen}
            onClose={() => {
              setUploadSdaOpen(false);
              closeAllSearches();
            }}
            onDownload={props.onDownload}
            otherSdaProperties={props.otherSdaProperties}
            county={props.county}
            orderId={props.order.id}
            propertyId={props.propertyId}
            getOrderDetails={props.getOrderDetails}
          />
        )}
      </OuterCard>
    </>
  );
};

export default PropertyCard;

interface PropTypes {
  searchType: string;
  dateOrdered: string;
  status?: string;
  fee?: number;
  order?: Order;
  searchId: number;
  documentsSearches: Document[];
  sdaOpen: any;
  updateSearch: (searchType: string, note: string) => Promise<void>;
  searchesToDownload: any;
  handleSearchCheckChange: any;
  completedStatus: boolean;
  closeDropdownForSearch: (searchId: number) => void;
  openDropdownForSearch: (searchId: number) => void;
  closeAllSearches: () => void;
  searchIdsOpen: number[];
  downloadSda:() => void;
}

const SearchCardMobile = (props: PropTypes) => {
  return (
    <>
      <SearchCardStyles>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ marginBottom: 8, width: '40%' }}>{props.searchType}</div>
          <div style={{ display: 'flex', alignItems: 'center', width: 160 }}>
            <span style={{ width: 140 }}>{props.status && <StatusLabel status={props.status} />}</span>
            <span style={{ marginLeft: 4 }}>
              {props.status === 'Completed' && <DownloadButton onClick={() => download(props)} />}
            </span>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: 6 }}>
          <div style={{ paddingRight: 16, width: '40%' }}>
            <SearchDetailTitle>Date Ordered</SearchDetailTitle>
            <div style={{ color: '#33322F' }}>{props.dateOrdered}</div>
          </div>
          {props.fee > 0 && (
            <div style={{ paddingRight: 16, width: 160 }}>
              <SearchDetailTitle>Town Fee</SearchDetailTitle>
              <div style={{ color: '#33322F' }}>{`$${props.fee}`}</div>
            </div>
          )}
        </div>
      </SearchCardStyles>
    </>
  );
};


